import { Button } from 'antd'
import React from 'react'
import styled from 'styled-components/macro'
import GrowthEngineHumanDemoRow from 'src/components/growthEngine/GrowthEngineHumanDemoRow'
import GrowthEngineManagerOnePager from 'src/components/growthEngine/GrowthEngineManagerOnePager'
import { PROGRESS_DISCOVERY_AFTER_WIN_LABEL } from 'src/utils/growthEngineProgressDiscovery'

/**
 * After a real first save: prove the outcome, keep the human, then one
 * optional next step. Quiet Progress link when venueId is known — benefit,
 * not a brochure. Do not auto-open a second form.
 */
const GrowthEngineFirstSuccessCompletion = ({
  outcome,
  nextSummary,
  ctaLabel,
  onCta,
  onProgress,
  featureId,
  featureLabel,
  managerOnePager,
  className,
  'data-testid': dataTestId = 'growth-engine-first-success-completion',
}) => {
  if (!outcome && !nextSummary) return null

  return (
    <Wrap
      className={className}
      data-testid={dataTestId}
      role='status'
      aria-label={outcome || 'First success'}
    >
      {outcome ? (
        <Outcome data-testid='guided-first-success-outcome'>{outcome}</Outcome>
      ) : null}
      {nextSummary ? (
        <NextSummary data-testid='guided-first-success-next'>
          {nextSummary}
        </NextSummary>
      ) : null}
      <GrowthEngineHumanDemoRow
        featureId={featureId}
        featureLabel={featureLabel}
      />
      <GrowthEngineManagerOnePager managerOnePager={managerOnePager} />
      {onCta && ctaLabel ? (
        <Button
          type='default'
          onClick={onCta}
          data-testid='guided-first-success-cta'
        >
          {ctaLabel}
        </Button>
      ) : null}
      {onProgress ? (
        <Button
          type='link'
          onClick={onProgress}
          data-testid='guided-first-success-progress'
        >
          {PROGRESS_DISCOVERY_AFTER_WIN_LABEL}
        </Button>
      ) : null}
    </Wrap>
  )
}

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px 8px 20px;
`

const Outcome = styled.p`
  color: ${({ theme }) => theme.colours.seaweedGreen || '#389e0d'};
  font-size: 15px;
  font-weight: 600;
  line-height: 1.4;
  margin: 0;
`

const NextSummary = styled.p`
  color: ${({ theme }) => theme.colours.oliveGrey || '#595959'};
  font-size: 14px;
  line-height: 1.5;
  margin: 0 0 4px;
`

export default GrowthEngineFirstSuccessCompletion
